import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { Tabs, Tab } from 'react-tab-view';
import { FaSpeakerDeck } from 'react-icons/fa';
import '../styles/tabbedviewStyles.css';

// 👇 tab screens
import Sports_Recreation from '../pages/imagePages/Sports_Recreation';
import Graduation from '../pages/imagePages/Graduation';
import Technovation from '../pages/imagePages/Technovation';
import HIT_in_pictures from '../pages/imagePages/HIT_in_pictures';
import Clubs from '../pages/imagePages/Clubs';

export default function GalleryTabbedView() {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        // console.log("\ntabRef:", tabRef.current?.refs);
    }, []);

    // 👇 handler for onChange
    const handChange = (e) => {
        console.log('\n\nonChange:', e);
    };

    // handler for rendering a page based on the selected menu.
    const getCurrentPage = () => {
        if (current === 0) return <Clubs />;
        else if (current === 1) return <Sports_Recreation />;
        else if (current === 2) return <Technovation />;
        else if (current === 3) return <Graduation />;
        else if (current === 4) return <HIT_in_pictures />;
    };

    const getStyles = (index) => {
        return {
            fontSize: current === index ? '2rem' : '1.5rem',
            color: current === index ? '#eee' : 'darkgrey',
            borderBottom: current === index ? '.2rem darkblue solid' : 'none',
            marginBottom: '.5rem',
        };
    };

    return (
        <div className='galleryTabbedView'>
            <div className='headers-container'>
                <div className='headers'>
                    <span
                        className='header-item'
                        style={getStyles(0)}
                        onClick={() => setCurrent(0)}
                    >
                        Clubs
                    </span>
                    <span
                        className='header-item'
                        style={getStyles(1)}
                        onClick={() => setCurrent(1)}
                    >
                        Sports & Recreation
                    </span>
                    <span
                        className='header-item'
                        style={getStyles(2)}
                        onClick={() => setCurrent(2)}
                    >
                        Technovation
                    </span>
                    <span
                        className='header-item'
                        style={getStyles(3)}
                        onClick={() => setCurrent(3)}
                    >
                        Graduation
                    </span>
                    <span
                        className='header-item'
                        style={getStyles(4)}
                        onClick={() => setCurrent(4)}
                    >
                        HIT in Pictures
                    </span>
                </div>
            </div>

            {getCurrentPage()}
        </div>
    );
}
